import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, CardElement, useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";
import { Typography, Row, Col, Card, Button, Collapse, Switch, Skeleton, Steps } from "antd";
import "../Plans/Plans.scss";
import "../../../../../../styles/helper.scss"
import axios from "axios";
import ENVIRONMENT from '../../../../../../environments'
import { LoadingOutlined } from "@ant-design/icons";
import PlanActivationAndPayment from "../PlanActivationAndPayment/PlanActivationAndPayment";
import { isValidPlan } from '../../utils/tierUtils';

const { Paragraph } = Typography;
const { Step } = Steps
const stripePromise = loadStripe(ENVIRONMENT.STRIPE_PUBLISH_KEY);
const CUSTOMER_USERNAME = localStorage.getItem('username')

const PlanSelection = () => {
    const [selectedPlanName, setSelectedPlanName] = useState(null)
    const [selectedPlanType, setSelectedPlanType] = useState('subscription')
    const [selectedBundleQuantity, setSelectedBundleQuantity] = useState(1)
    const [annualSetting, setAnnualSetting] = useState(true);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        let URLParams = new URLSearchParams(window.location.search);
        let plan = URLParams.get('plan')
        let planType = URLParams.get('plan_type')
        let quantity = URLParams.get('quantity')
        if(plan == 'free_trial_ai'){
            setAnnualSetting(false);
            window.location.href = '/'
            return
        }
        if (plan && !isValidPlan(plan)) {
            window.location.href = '/'
            return
        }
        if (plan && plan.includes('annual_') && planType == 'subscription'){
            setAnnualSetting(true);
        } else if (plan && planType == 'subscription'){
            setAnnualSetting(false);
        }
        setSelectedPlanName(plan)
        setSelectedPlanType(planType)
        if(planType == 'bundle' && quantity){
            setSelectedBundleQuantity(quantity)
        }
        setReady(true);
    }, [])


    return (
        <Row className='justify-on-mobile'>
            <Col span={12} className='hide-on-mobile'>
                <img
                className="branding-image"
                alt="Brand Image"
                src={'/img/introImage.png'}
                />
            </Col>
            <Col xs={22} sm={22} md={24} lg={12} className='web-desktop-width planning-comp-width'>
               {ready ? (
                   <PlanActivationAndPayment
                   selectedPlanName={selectedPlanName}
                   signUpFlow={true}
                   annualSetting={annualSetting}
                   setAnnualSetting={setAnnualSetting}
                   subscriptionType={selectedPlanType}
                   selectedBundleQuantity={selectedBundleQuantity} />
               ) : (
                   <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '48px 0' }}>
                       <LoadingOutlined style={{ fontSize: 24 }} />
                   </div>
               )}
            </Col>
        </Row >
    );
};


export default PlanSelection;
